import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { SquareObjectDataset } from 'app/model/dataset/square.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SquareObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class SquareObjectDatasetAdapter extends TabularTypeDatasetAdapter<SquareObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SquareObjectDataset): Promise<Model.DatasetResource> {
        return this._toResourceInternal(dataset, Metamodel.modelFor(SquareObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SquareObjectDataset): Promise<SquareObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SquareObjectDataset.MODEL);
    }
}
